function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9998 25.666C15.2832 25.666 16.3332 24.616 16.3332 23.3327H11.6665C11.6665 24.616 12.7165 25.666 13.9998 25.666ZM20.9998 18.666V12.8327C20.9998 9.25102 19.0982 6.25268 15.7498 5.45935V4.66602C15.7498 3.69768 14.9682 2.91602 13.9998 2.91602C13.0315 2.91602 12.2498 3.69768 12.2498 4.66602V5.45935C8.91317 6.25268 6.99984 9.23935 6.99984 12.8327V18.666L4.6665 20.9993V22.166H23.3332V20.9993L20.9998 18.666ZM18.6665 19.8327H9.33317V12.8327C9.33317 9.93935 11.0948 7.58268 13.9998 7.58268C16.9048 7.58268 18.6665 9.93935 18.6665 12.8327V19.8327Z",
  fill: "currentColor"
});
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.c92d9b30.svg";
export { ForwardRef as ReactComponent };